export enum BlueBoxTextType {

  hidden = -1,
  callTarget = 0

}